<template>
  <div v-show="visible">
    <van-picker
      show-toolbar
      cancel-button-text
      :confirm-button-text="dataSchool.items.length <= 0 ? '-' : '确定'"
      @confirm="confirm"
      @cancel="cancel"
      :columns="dataSchool.items"
      visible-item-count="6"
      :loading="dataSchool.loading"
      :value-key="valuekey"
      @change="change"
    >
      <template #title></template>

      <template #columns-top>
        <div style="width: 100%; border-top: 3px solid #eeeeee">
          <van-search
            show-action
            placeholder="请输入学校关键词(全国范围)"
            v-model="keyword"
            @search="
              searchtype = 'search';
              getList();
            "
          >
            <template #action>
              <div style="display: flex; justify-content: center">
                <van-button
                  size="small"
                  @click="
                    searchtype = 'search';
                    getList();
                  "
                  style="margin: 0px"
                  :disabled="!keyword"
                >搜索学校</van-button>
              </div>
              <!-- <div @click="searchtype='search';getList();">搜索</div> -->
            </template>
          </van-search>
        </div>
        <div style="width: 100%; padding-left: 5px; padding-right: 5px" class="van-ellipsis">
          <a style="color: blue; font-weight: 800">
            {{
            searchtype == "city" ? cityName : searchedName ? searchedName : ""
            }}
          </a>
          共
          <a style="color: red; font-weight: 800">{{ dataSchool.dataTotal }}</a>所
        </div>
      </template>

      <template #columns-bottom>
        <div
          class="van-ellipsis"
          style="width: 100%; padding: 5px; color: green; font-weight: 800"
          v-if="selected"
        >当前选择:{{ selected[valuekey] }}</div>
        <!-- <div class="_columns-bottom">
          <el-button class="_btn" @click="cancel">取消</el-button>
          <el-button
            type="primary"
            class="_btn"
            @click="confirm"
            :disabled="dataSchool.items.length<=0"
          >确定选择</el-button>
        </div>-->
        <!-- <div style="width:100%;height:80px" v-if="selectedAddr">当前:{{selectedAddr}}</div> -->
      </template>
    </van-picker>
  </div>
</template>

<script>
// import areaList from "../area"
export default {
  props: {
    selectedArea: {
      default: null
    },
    areaid: {
      type: String,
      default: null
    },
    cityName: {
      type: String,
      default: ""
    },
    visible: {
      type: Boolean,
      default: false
    },
    valuekey: {
      type: String,
      default: "Schoolname"
    }
  },
  data() {
    return {
      searchtype: "city",
      cityname: "",
      selected: null,
      // 省份
      Province: "",
      // 省份id
      Provinceid: "",
      // 所在城市id
      Cityid: "",
      // 区县id
      Areaid: "",
      keyword: "",
      searchedName: "",
      dataSchool: {
        items: [],
        dataTotal: 0,
        loading: false
      },
      columns: [],

      other: {
        Area: "其它",
        Areaid: "1",
        City: "其它",
        Cityid: "1",
        Id: 11048,
        Province: "其它",
        Provinceid: "1",
        Schoolname: "其它"
      }
    };
  },

  created() {
    console.log(this.selectedArea);
    if (this.selectedArea) {
      // this.Areaid = this.selectedArea[1].code;
      // 省分名字
      this.Province = this.selectedArea[0].name;
      this.Cityid = this.selectedArea[1].code;
      this.Provinceid = this.selectedArea[0].code;
    }

    if (!this.Cityid || !this.Province) {
      console.log("请先选择省市区");
    }
    this.searchtype = "city";
    this.getList();
  },
  methods: {
    getList() {
      console.log(this.searchtype);
      let that = this;
      var params = {};
      params.Page = 1;
      params.Tracestatus=2;
      params.Limit = 100;
      if (this.searchtype == "city") {
        if (!this.Cityid || !this.Province) {
          this.$toast("请选择省市");
          return;
        }
        params.Cityid = this.Cityid;
        params.Province = this.Province;
        console.log(params);
      } else {
        if (!this.keyword) {
          this.$toast("请输入学校关键字搜索");
          return;
        }
        params.Name = this.keyword;
      }
      this.searchedName = "";
      this.dataSchool.loading = true;
      this.selected = null;
      this.axios
        .get("/api/hs/find", {
          params: params
        })
        .then(res => {
          console.log(res);
          that.searchedName = that.keyword + "";
          if (res.data.code == 0 && res.data.data.List) {
            that.dataSchool.items = res.data.data.List;
            if (!that.selected && that.dataSchool.items.length > 0) {
              that.selected = that.dataSchool.items[0];
            }
            that.dataSchool.dataTotal = res.data.data.Total;
          } else {
            that.dataSchool.items = [];
            that.dataSchool.dataTotal = 0;
            // that.$toast("搜索失败");
          }
console.log(that.dataSchool.items);

          if (that.dataSchool.items.length == 0) {
            that.dataSchool.items = [...that.dataSchool.items, ...[that.other]];
            that.dataSchool.dataTotal += 1;
          }
          that.dataSchool.loading = false;
          // that.areaList = res.data.data;
        });
    },

    confirm() {
      if (!this.dataSchool.items || this.dataSchool.items.length < 0) {
        return;
      }
      if (!this.selected) {
        this.selected = this.dataSchool.items[0];
      }
      // if (this.checkdata(dataarr)) {
      this.$emit("confirm", this.selected);
      //   this.cancel();
      // }
    },
    cancel() {
      this.$emit("cancel");
      // console.log("dsdsd")
      this.$emit("update:visible", false);
    },
    change(picker, selectedobj, index) {
      this.selected = selectedobj;
      // console.log("选择了：" + JSON.stringify(selectedobj) + "-lie：" + index)

      // this.selectedArray = values;
      // this.selectedAddr = (values[0] && values[0].name ? values[0].name : "") + (values[1] && values[1].name ? "-" + values[1].name : "") + (values[2] && values[2].name ? "-" + values[2].name : "")
      // console.log(values)
    }
  }
};
</script>

<style scoped>
._columns-bottom {
  width: 100%;
  display: flex;
  padding: 5px;
}

._columns-bottom ._btn {
  flex: 1;
}
.van-picker /deep/ .van-picker__confirm{
  background-color: #07c160;
    border: 1px solid #07c160;
    color: #ffffff;
    width: 100px;
}
.van-picker /deep/ .van-picker-column__item.van-picker-column__item--selected{

  animation: 1s bigbig linear infinite normal;

  /* animation: 1s bigbig linear; */
}
@keyframes bigbig {
  0% {
    transform: translateX(0) scale(1);
    -webkit-transform: translateX(0) scale(1);
  }
  50% {
    transform: scale(1.2);
    -webkit-transform: scale(1.2);
  }
  100% {
    transform: scale(1);
    -webkit-transform: scale(1);
  }
}
</style>



// WEBPACK FOOTER //
// src/components/school.vue